import React, { useState } from "react";
import EventsTab from "./EventsTab";
import SelectCustom from "../common/SelectCustom";
import { GeoAlt } from "react-bootstrap-icons";
// import { useQuery } from "react-query";
// import axios from "axios";

const UpcomingEvents = React.memo(function UpcomingEvents({ locations }) {
  let locationSelectedOption = {
    label: "Everywhere",
    value: 1,
  };
  const [location, setLocation] = useState(locationSelectedOption.value);

  const showSelect = () => {
    var select = document.getElementById("locationSelec");
    select.style.display = "block";
    var LocationShow = document.getElementById("locationShow");
    LocationShow.style.display = "none";
    var myButton = document.getElementById("eventChangeLocation");
    myButton.style.display = "none";
  };
  const onLocationSelect = (location_id, location) => {
    var select = document.getElementById("locationSelec");
    select.style.display = "none";
    var LocationShow = document.getElementById("locationShow");
    LocationShow.style.display = "block";
    LocationShow.innerHTML = `<h3 className="location-show">${location}</h3>`;
    var myButton = document.getElementById("eventChangeLocation");
    myButton.style.display = "block";
    locationSelectedOption.label = location;
    locationSelectedOption.value = location_id;
    setLocation(location_id);
  };

  // If locations are not loaded yet, show minimal skeleton
  if (!locations) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
            <h6 className="upcoming-events-title">Upcoming events</h6>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="upcoming-events-location">
              <div className="row justify-content-center">
                <div className="col-auto hidden-xs hidden-xxs">
                  <div
                    style={{
                      width: "auto",
                      height: "30px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "50%",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  ></div>
                </div>
                <div className="col-auto location-select text-center">
                  <div
                    style={{
                      height: "24px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                      width: "120px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  ></div>
                </div>
                <div className="col-auto">
                  <div
                    style={{
                      height: "32px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                      width: "100px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  // If locations are not loaded yet, show skeleton
  if (!locations) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
            <h6 className="upcoming-events-title">Upcoming events</h6>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="upcoming-events-location">
              <div className="row justify-content-center">
                <div className="col-auto hidden-xs hidden-xxs">
                  <div
                    style={{
                      width: "auto",
                      height: "30px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "50%",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  ></div>
                </div>
                <div className="col-auto location-select text-center">
                  <div
                    style={{
                      height: "24px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                      width: "120px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  ></div>
                </div>
                <div className="col-auto">
                  <div
                    style={{
                      height: "32px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                      width: "100px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          {/* Events Tab Skeleton */}
          <div className="col-lg-12">
            <div style={{ marginTop: "20px" }}>
              {Array.from({ length: 8 }).map((_, index) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 card-holder" key={`tab-skeleton-${index}`} style={{ display: "inline-block", margin: "10px" }}>
                  <div className="card">
                    <div style={{ height: "200px" }}>
                      <div style={{ height: "100%", backgroundColor: "#f0f0f0", borderRadius: "8px 8px 0 0", animation: "pulse 1.5s ease-in-out infinite" }}></div>
                    </div>
                    <div className="card-body">
                      <div style={{ height: "16px", backgroundColor: "#f0f0f0", borderRadius: "4px", marginBottom: "6px", animation: "pulse 1.5s ease-in-out infinite" }}></div>
                      <div style={{ height: "14px", backgroundColor: "#e0e0e0", borderRadius: "4px", width: "80%", animation: "pulse 1.5s ease-in-out infinite" }}></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
          <h6 className="upcoming-events-title">Upcoming events</h6>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="upcoming-events-location">
            <div className="row justify-content-center">
              <div className="col-auto hidden-xs hidden-xxs">
                <GeoAlt size={30} color="#667085" />
              </div>
              {locations && (
                <div className="col-auto location-select text-center" style={{ position: "relative", minWidth: "200px" }}>
                  <div
                    id={"locationSelec"}
                    style={{
                      display: "none",
                      zIndex: 9999,
                      position: "absolute",
                    }}
                  >
                    <SelectCustom id={"location_select"} options={locations} selectedOption={locationSelectedOption} onChange={onLocationSelect} />
                  </div>
                  <div id={"locationShow"} style={{ display: "block" }}>
                    <h3 className="location-show">{locationSelectedOption.label}</h3>
                  </div>
                </div>
              )}
              <div className="col-auto">
                <button className="event-btn-change-city" id="eventChangeLocation" onClick={showSelect}>
                  Change city
                </button>
              </div>
            </div>
          </div>
        </div>
        <EventsTab locationId={location} />
      </div>
    </div>
  );
});

export default UpcomingEvents;
